export const contact = {
  "contact.title": "Contactez-nous",
  "contact.subtitle": "Notre équipe est là pour vous aider. N'hésitez pas à nous contacter pour toute question ou suggestion.",
  "contact.form_title": "Envoyez-nous un message",
  "contact.success": "Votre message a été envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.",
  "contact.error": "Une erreur s'est produite. Veuillez réessayer plus tard.",
  "contact.name": "Nom complet",
  "contact.email": "Email",
  "contact.type": "Type de demande",
  "contact.subject": "Sujet",
  "contact.message": "Message",
  "contact.send": "Envoyer le message",
  "contact.sending": "Envoi en cours...",
  "contact.type_general": "Question générale",
  "contact.type_supplier": "Devenir fournisseur",
  "contact.type_technical": "Support technique",
  "contact.type_partnership": "Partenariat",
  "contact.type_feedback": "Feedback",
  "contact.info_title": "Informations de contact",
  "contact.address_title": "Adresse",
  "contact.address_text": "Office 234, GCL Plaza\n7th Avenue, Festac. LAGOS",
  "contact.phone_title": "Téléphone",
  "contact.email_title": "Email",
  "contact.email_text": "suji@olufona.com",
  "contact.hours_title": "Horaires",
  "contact.hours_text": "Lundi - Vendredi: 9h00 - 18h00\nSamedi: 10h00 - 16h00\nDimanche: Fermé",
  "contact.faq_title": "Questions fréquentes",
  "contact.faq_text": "Consultez notre FAQ pour trouver rapidement des réponses aux questions les plus courantes.",
  "contact.see_faq": "Voir la FAQ",
  "contact.placeholder_name": "Votre nom complet",
  "contact.placeholder_email": "votre@email.com",
  "contact.placeholder_subject": "Sujet de votre message",
  "contact.placeholder_message": "Décrivez votre demande en détail...",
  "contact.char_count": "caractères",
  "contact.rate_limited": "Trop de demandes. Veuillez réessayer plus tard.",
  "contact.try_again_after": "Réessayez après",
  "contact.office_name": "Bureau Suji",
  "contact.office_address": "GCL Plaza, 7th Avenue, Festac, Lagos"
};

export default contact;
